export const ageGroupOptions = [
  {
    value: "Pre-K (3-5)",
    display: "Under 5",
    label: "Under 5",
    min: 3,
    max: 5,
  },
  {
    value: "Elementary School (5-11)",
    display: "Age 5-11",
    label: "Age 5-11",
    min: 5,
    max: 11,
  },
  {
    value: "Middle School (12-14)",
    display: "Age 12-14",
    label: "Age 12-14",
    min: 12,
    max: 14,
  },
  {
    value: "High School (14-18)",
    display: "Age 14-18",
    label: "Age 14-18",
    min: 14,
    max: 18,
  },
  { value: "College", label: "Age 19-24", min: 19, max: 24 },
  { value: "Adult", label: "Adult", min: 24, max: 99 },
];

export const getAgeGroupRange = (values = []) => {
  const ages = [];
  values.forEach((v) => {
    ageGroupOptions
      .filter((a) => a.value === v)
      .forEach((a) => {
        ages.push(a.min);
        ages.push(a.max);
      });
  });

  let min = Math.min(...ages),
    max = Math.max(...ages);

  return {
    min: min || 3,
    max: max || 18,
  };
};

export const ageSelectOptions = () => {
  let opts = [{ label: "All Ages", value: "" }];
  // for (var i = 3; i < 19; i++) {
  //   opts.push({ label: i, value: i });
  // }
  ageGroupOptions.forEach((a) => opts.push({ label: a.label, value: a.value }));
  return opts;
};
